export const PageLoader = () => {
    return (
        <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '88vh' }} >
            <div className="page-loader"></div>
        </div>
    )
}